var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLevel1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#af9b5b;stroke-linecap:round;stroke-linejoin:round;}.cls-2{fill:#af975c;opacity:0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "niveau1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.9,17.69a2.67,2.67,0,0,1-.22-5.34,3.29,3.29,0,1,1,6.58.17,2.56,2.56,0,0,1,1-.18,2.68,2.68,0,1,1,0,5.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "35.36 26.9 38.2 31.91 22.41 31.91 25.25 26.9 22.41 26.9 26.03 20.51 23.82 20.51 30.3 9.05 36.77 20.51 34.58 20.51 38.2 26.9 35.36 26.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27,35.73c.74,0,1.46.05,2.18.11V34.33a5.18,5.18,0,0,0-8.52,1.54,4.1,4.1,0,0,0-1.22-.2,4.31,4.31,0,0,0-4.25,3.63A19.89,19.89,0,0,1,27,35.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.74,38.57h.19a6.37,6.37,0,0,0-5.5-3.16,5.56,5.56,0,0,0-1,.1v.66A19.06,19.06,0,0,1,37.74,38.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.43,36.17V31.91H29.18v3.93A20.3,20.3,0,0,1,31.43,36.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42,42.86c-2.26-4.16-8.12-7.13-15-7.13s-12.74,3-15,7.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 55,
    height: 55
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLevel1);
export default __webpack_public_path__ + "static/media/icon_level_1.3528bf251163b01b3418b61ef60a829a.svg";
export { ForwardRef as ReactComponent };